import React, { useState, useEffect } from 'react';
import { Chip, Box } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useNavigate } from 'react-router-dom';
import { keyframes } from '@mui/system';

const STORAGE_KEY = 'pendingBuildPrompt';

const wiggle = keyframes`
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-0.8deg); }
    50% { transform: rotate(0.8deg); }
    75% { transform: rotate(-0.4deg); }
`;

const pulse = keyframes`
    0%, 100% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.3); }
    50% { box-shadow: 0 0 0 6px rgba(25, 118, 210, 0); }
`;

const truncate = (text, maxLen = 50) => {
    if (!text || text.length <= maxLen) return text;
    return text.substring(0, maxLen).trim() + '...';
};

export const PendingBuildChip = () => {
    const [prompt, setPrompt] = useState(() => localStorage.getItem(STORAGE_KEY));
    const navigate = useNavigate();

    useEffect(() => {
        const handleStorage = () => setPrompt(localStorage.getItem(STORAGE_KEY));
        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    if (!prompt) return null;

    const dismiss = (e) => {
        e.stopPropagation();
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem('pendingInstallUrl');
        setPrompt(null);
    };

    return (
        <Box sx={{
            position: 'fixed',
            top: 12,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 99999,
        }}>
            <Chip
                icon={<RocketLaunchIcon sx={{ fontSize: 16 }} />}
                label={truncate(prompt)}
                onDelete={dismiss}
                onClick={() => navigate('/subscriptions')}
                sx={{
                    maxWidth: 420,
                    height: 32,
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                    backgroundColor: 'rgba(25, 118, 210, 0.1)',
                    border: '1px solid rgba(25, 118, 210, 0.3)',
                    animation: `${wiggle} 4s ease-in-out infinite, ${pulse} 3s ease-in-out infinite`,
                    '&:hover': {
                        backgroundColor: 'rgba(25, 118, 210, 0.2)',
                        animation: 'none',
                    },
                    '& .MuiChip-deleteIcon': {
                        color: 'rgba(0,0,0,0.4)',
                        '&:hover': { color: 'rgba(0,0,0,0.7)' }
                    }
                }}
            />
        </Box>
    );
};
